'use strict';
module.exports = require('./TabPanel.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/tabpanel/index.js
// module id = 59
// module chunks = 7